/* eslint-disable */


/**
 * Create styles for `<Banner />`
 * @param {any} theme The theme
 * @returns The `<Banner />` styles
 */
const bannerStyles = ({ theme }) => {
  return {
    bannerAppBar: {
      backgroundColor: theme.palette.common.white,
      boxShadow: `none`,
      position: `unset`,
      top: `auto`,
    },
    bannerIcon: {
      fill: `orange`,
      marginRight: theme.spacing(1) * 2,
    },
    bannerLink: {
      color: `inherit`,
    },
    bannerToolbar: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
  };
};

export default bannerStyles;
